import {getFacilityList} from '@/helper'

const facilityStore = {
  state: {
    facilityList: [{
      facility_name: null,
      description: '',
      meta: null,
      sampling_freq: 0
    }],
    facilityLoaded: false
  },
  actions: {
    async refreshFacilityList (context) {
      let result = await getFacilityList()
      context.commit('updateFacilityList', result)
    }
  },
  mutations: {
    updateFacilityList (state, payload) {
      state.facilityList = payload['facilities']
      state.facilityLoaded = true
    }
  }
}

export default facilityStore
